import { DispensaryCollectionsPage } from 'src/dispensary/collections';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

export default Object.assign(DispensaryCollectionsPage, { layout: MainDispensaryLayout });
